import { render, staticRenderFns } from "./oneKeyBooking.vue?vue&type=template&id=3384ece6&scoped=true&"
import script from "./oneKeyBooking.vue?vue&type=script&lang=js&"
export * from "./oneKeyBooking.vue?vue&type=script&lang=js&"
import style0 from "./oneKeyBooking.vue?vue&type=style&index=0&id=3384ece6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3384ece6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3384ece6')) {
      api.createRecord('3384ece6', component.options)
    } else {
      api.reload('3384ece6', component.options)
    }
    module.hot.accept("./oneKeyBooking.vue?vue&type=template&id=3384ece6&scoped=true&", function () {
      api.rerender('3384ece6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/edi/oneKeyBooking.vue"
export default component.exports